import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../../atoms/Icon';
import Headline from '../../atoms/Headline';
import { SantanderLogo } from '../../atoms/Logos';
import { GfdbLogoOriginal } from '../../atoms/Logos';
import { getPaymentGroupLabel } from '../../../utils';
var AppConfig = require('../../../config.json');
/**
 * A simple PaymentDisplay.
 */

class PaymentDisplay extends React.Component {
	
    render () {
    	const { label, subline } = getPaymentGroupLabel(this.props.choice);
        return (
          <div className="paymentdisplay selected">
            {
                this.props.choice.type==='sf' &&
                <SantanderLogo />
            }
            {
                (this.props.choice.type==='pc' || this.props.choice.type==='sos') &&
                <GfdbLogoOriginal />
            }
            <Icon filename="selected" />
            <div className="inner">
            	<div className="desc">
	            	<Headline typeOf="h3" alignment="center">
	              		{label}
	              	</Headline>
	              	<div className="subline" style={{color:"#222"}}>
	              		{subline}
	              	</div>
                    {
                        this.props.choice.type==='pc' &&
                        <div className="cashdiscount">{AppConfig.payments.cashdiscount}</div>
                    }
            	</div>
            </div>
          </div>
        );
    }

}

PaymentDisplay.propTypes = {
	/** Button label */
	choice: PropTypes.object.isRequired
}


export default PaymentDisplay;





// WEBPACK FOOTER //
// ./src/components/molecules/PaymentDisplay/PaymentDisplay.js